import { FC } from 'react'
import classNames from 'classnames'
import en from 'src/constants/en'
import { useGetSuggestWordQuery } from 'src/reactQuery/useGetSuggestWordQuery'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { AutofillInput } from 'src/components/AutofillInput'
import Button from 'src/components/Button'
import styles from './addKeywordInput.module.scss'

interface AddKeywordInputProps {
  addNewKeyword: () => void
  currentKeywordInput: string
  disabled?: boolean
  keywordCount?: number
  onUploadClick?: () => void
  setCurrentKeywordInput: (value: string) => void
  variationsCount?: number
}

export const AddKeywordInput: FC<AddKeywordInputProps> = ({
  currentKeywordInput,
  setCurrentKeywordInput,
  addNewKeyword,
  keywordCount = 0,
  variationsCount = 0,
  onUploadClick,
}) => {
  const { data: suggestionData, handleSearch } = useGetSuggestWordQuery({
    queryKey: QueryKey.SUGGEST_WORD_CREATE_CAMPAIGN_KEYWORD,
  })

  const suggestedWord = suggestionData?.suggested_word || ''

  return (
    <div className={styles.addKeywordInputWrapper}>
      <div className={styles.labelWrapper}>
        <span className={styles.label}>Target Keyword</span>
        <span className={styles.counters}>
          <span className={styles.countValue}>{keywordCount}</span>
          <span className={styles.countLabel}>&nbsp;Keywords Added</span>
          <span className={styles.countSep}>&nbsp;/&nbsp;</span>
          <span className={styles.countValue}>{variationsCount}</span>
          <span className={styles.countLabel}>&nbsp;Variations Added</span>
        </span>
      </div>

      <div className={styles.addKeywordInputInner}>
        <AutofillInput
          addTag={() => addNewKeyword()}
          autoFillClassName={classNames(styles.addKeywordAutoFill)}
          autofilldWord={suggestedWord}
          fillKey={() => setCurrentKeywordInput(suggestedWord)}
          inputClassName={styles.addKeywordInput}
          isFullWidth
          isInputKeyword
          onChange={(value) => {
            setCurrentKeywordInput(value)
            if (value.length > 1) {
              handleSearch(value)
            }
          }}
          placeHolder="Enter or Upload Keywords"
          value={currentKeywordInput}
        />

        <button
          className={styles.uploadWrapper}
          onClick={onUploadClick}
          type="button"
        >
          {/* vuesax/linear/paperclip-2 */}
          <svg fill="none" height="16" viewBox="0 0 24 24" width="16">
            <path
              d="M12.188 12.583 9.84 14.93a3.133 3.133 0 1 1-4.43-4.43l5.664-5.664a4.179 4.179 0 0 1 5.906 5.907l-5.674 5.663c-.021.021-.042.031-.062.052a2.5 2.5 0 0 1-3.46-3.606c.02-.021.031-.052.052-.073l4.717-4.717"
              stroke="#8080FF"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="1.5"
            />
          </svg>
          <span className={styles.uploadText}>Upload Keywords</span>
        </button>

        <Button
          className={styles.addButton}
          onClick={addNewKeyword}
          type="button"
        >
          {en.add}
        </Button>
      </div>
    </div>
  )
}
